import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=406984c0&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=406984c0&prod&lang=css"
import style1 from "./TheHeader.vue?vue&type=style&index=1&id=406984c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406984c0",
  null
  
)

export default component.exports